import 'core-js/fn/array/find';
import 'core-js/fn/number/parse-int';
import './assets/styles/index.scss';
import 'moment/locale/tr';
import { connect, Provider } from 'react-redux';
import { ConnectedRouter, history } from '@arkas/core';
import { IntlProvider, addLocaleData } from 'react-intl';
import { OidcProvider, loadUser } from 'redux-oidc';
import {
  setRequestInterceptor,
  setResponseInterceptor
} from './helpers/axiosHelper';
import App from './App';
import { applicationState } from './states/applicationState';
import enLocaleData from 'react-intl/locale-data/en';
import { loadProgressBar } from './helpers/nprogressHelper';
import locals from './i18n/locales';
import lodash from 'lodash';
import moment from 'moment';
import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
import { Store } from 'redux';
import trLocaleData from 'react-intl/locale-data/tr';
import { UserDto } from '@emutabakat-types/anaveri';
import userManager from './oidc/userManager';

interface RootProps {
  currentUser: UserDto;
  store: Store<Object>;
}

interface RootState {
  language: string;
}

loadProgressBar({});
setRequestInterceptor(store);
setResponseInterceptor();
loadUser(store, userManager);
addLocaleData(trLocaleData);
addLocaleData(enLocaleData);
moment.locale('tr');

/**
 * Root Component
 */
class Root extends React.Component<RootProps, RootState> {
  constructor(props: RootProps) {
    super(props);
    const { currentUser } = this.props;
    this.state = {
      language: !lodash.isEmpty(currentUser)
        ? currentUser.tercihEdilenDil
        : 'tr'
    };
  }

  componentDidMount() {}
  shouldComponentUpdate() {
    return true;
  }
  componentDidUpdate(prevProps: RootProps) {
    const { currentUser } = this.props;
    const prevUser = prevProps.currentUser;
    if (!lodash.isEmpty(currentUser) && lodash.isEmpty(prevUser)) {
      if (currentUser.tercihEdilenDil !== prevUser.tercihEdilenDil) {
        if (!currentUser.isArkasUser && currentUser.tercihEdilenDil === 'en') {
          this.setState({ language: currentUser.tercihEdilenDil });
          window.location.reload();
        }
      }
    }
  }
  render() {
    const { language } = this.state;
    const local = language === 'tr' ? locals['tr'] : locals['en'];
    return (
      <Provider store={store}>
        <IntlProvider locale={language} messages={local}>
          <OidcProvider store={store} userManager={userManager}>
            <ConnectedRouter history={history}>
              <App />
            </ConnectedRouter>
          </OidcProvider>
        </IntlProvider>
      </Provider>
    );
  }
}

const mapStateToProps = (state: applicationState) => {
  return {
    currentUser: state.kullaniciModel.currentUser
  };
};

const ConnectedRoot = connect(mapStateToProps)(Root);

ReactDOM.render(
  <ConnectedRoot store={store} />,
  document.getElementById('root')
);
